React = require 'react'
t = require('views/internal/recup-with-helpers')('team_list_component')

module.exports = class extends React.Component
  render: t.renderable ->
    { members } = @props

    t.ul ->
      members.forEach (member) ->
        t.li ->
          t.text "#{ member.fullName } (#{ member.username })"



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/join-request-members-component.coffee